/**
 * UranIA PA — `/piattaforma` (cos'è UranIA, governance, modello di IA).
 *
 * Pagina istituzionale nuova (Riordino della mappa delle rotte §3/§4,
 * Rilascio A passo A.7): "già promessa dai link di copertina" — il CTA
 * secondario "LA PIATTAFORMA" in `OverviewPage` era disabilitato proprio
 * perché non esisteva un equivalente reale (vedi `features/overview/OverviewPage.tsx`);
 * ora lo è, quel CTA è stato riattivato verso qui.
 *
 * Contenuto: riassunto factual da CLAUDE.md ("What UranIA PA does"),
 * nessuna nuova rivendicazione. La sezione di governance è
 * deliberatamente minima — dettagli come il fallback fra provider LLM
 * sono interni (docs/architettura), non materiale da esporre su una
 * pagina pubblica.
 */

import { useTranslation } from 'react-i18next';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { InstitutionalPageShell } from '../features/sistema/InstitutionalPageShell.tsx';
import { Route as PubblicoRoute } from './_pubblico.tsx';

function PiattaformaPage(): JSX.Element {
  const { t } = useTranslation();
  const capacita = t('istituzionale.piattaforma.capacita', { returnObjects: true }) as readonly string[];

  return (
    <InstitutionalPageShell
      badge={t('istituzionale.piattaforma.badge')}
      title={t('istituzionale.piattaforma.title')}
      testId="piattaforma-page"
    >
      <p className="lead">{t('istituzionale.piattaforma.intro')}</p>
      <h2 className="h5 mt-4 mb-2">{t('istituzionale.piattaforma.capacita_titolo')}</h2>
      <ul>
        {capacita.map((voce) => (
          <li key={voce} className="mb-1">
            {voce}
          </li>
        ))}
      </ul>
      <h2 className="h5 mt-4 mb-2">{t('istituzionale.piattaforma.governance_titolo')}</h2>
      <p className="text-muted">{t('istituzionale.piattaforma.governance_pending')}</p>
    </InstitutionalPageShell>
  );
}

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/piattaforma',
  component: PiattaformaPage,
});
